import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileZip.tsx
const IconFileZip = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M8 4V2H1.993A1 1 0 0 0 1 2.992v18.016c0 .548.445.992.993.992h16.014a1 1 0 0 0 .993-.992V18h-9a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2H8V6h2V4z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M10 2v2h2v2h-2v2h9V2.992A.993.993 0 0 0 18.007 2z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#f0ae2e",
			fillRule: "evenodd",
			d: "M10 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm4.81 6.088v-.726h.54v-2.736h-.54V10.9h1.993v.726h-.54v2.736h.54v.726zm-.57-4.184h-2.778v.81h1.817l-1.817 2.568v.806l2.913.004v-.81h-1.81l1.809-2.568v-.81zm2.965 4.188v-4.188h1.98q.294 0 .528.102.234.096.396.27.168.174.258.426.09.246.09.54 0 .3-.09.546t-.258.42q-.162.174-.396.276a1.4 1.4 0 0 1-.528.096h-1.068v1.512zm1.872-2.304h-.96v-1.092h.96q.204 0 .318.108.12.102.12.306v.264q0 .204-.12.312a.46.46 0 0 1-.318.102",
			clipRule: "evenodd"
		})
	]
});
var IconFileZip_default = forwardRef(IconFileZip);
//#endregion
export { IconFileZip_default as default };
